import React from 'react';
import PropTypes from "prop-types";
import ReactDOM from 'react-dom';
import Footer from './footer.jsx';
import Header from './header.jsx';


const MAX_GAME_NAME = 40;

class CustomView extends React.Component {

    constructor() {
        super();

        this.state = {
            name: "",
        }
    }

    handleChange(event) {

        this.setState({
            name: event.target.value.substring(0, MAX_GAME_NAME).replace("\n", ""),
        });
    }

    clickCreate() {
        this.props.clickCreate();
    }
    
    clickJoin() {
        this.props.clickJoin(this.state.name || '');
    }

	render() {

        return (
            <div class="main" id="main">
                <canvas id="backCanvas" class="backCanvas"></canvas>
                <Header clickBack={this.props.clickBack}/>

                <div class="middle" id="nickname">
                    <h3>
                        Custom Game:<br/><br/>

                        <button onClick={this.clickCreate.bind(this)} class="button1">Create Room</button>
                        <div class="vPadding"></div>
                        <br/><br/>

                        <input value={this.state.name} onChange={this.handleChange.bind(this)} 
                            autocomplete="off" type="text" id="name" placeholder={ this.props.defaultName }></input>
                        <button onClick={this.clickJoin.bind(this)} class="button1">Join Room</button>
                    </h3>
                </div>

                <Footer/>
            </div>
        );
	}
}

CustomView.propTypes = {
  clickCreate: PropTypes.func,
  clickJoin: PropTypes.func,
  clickBack: PropTypes.func,
};


export default CustomView;